import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { ProductsList } from '../app/components/product/products-list';
import { ProtectedRoute } from '@org/ui';

export const Route = createFileRoute('/products')({
  component: ProductsRoute,
});

function ProductsRoute() {
  const navigate = useNavigate({ from: '/products' });

  return (
    <ProtectedRoute requiredPermissions={['admin:all', 'products:*']}>
      <div className="space-y-6">
        <ProductsList
          onCreateProduct={() => navigate({ to: '/products/new' })}
          onEditProduct={(product) =>
            navigate({ to: '/products/$productId', params: { productId: product.productId } })
          }
        />
        <Outlet />
      </div>
    </ProtectedRoute>
  );
}
